import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Loader, Text, TextInput, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';
import Grid from "@mui/material/Grid";

import Header from '../../components/Header.js';
import ClaimBlock from './components/ClaimBlock.js';
import { getClaims, getAgentBenefitAssignments } from '../../actions/adjudication.js';
import permissionLevel from '../../services/permissions.js';
import AgentBenefitAssignment from './components/AgentBenefitAssignment.js';
import PermissionsComponent from '../../components/PermissionsComponent.js'; 

class ClaimsList extends PureComponent {
    state = {
        service: null,
        benefit: null,
        status: 'Pending',
        assignedTo: (!this.props.master.isAdjudicator || this.props.master.access.toUpperCase() === 'MASTER') ? 'All' : `${ this.props.master.firstname } ${ this.props.master.lastname }`,
        type: null,
        sortBy: null,
        query: null,
        sortDirection: 'ASC',
        showDropZone: false,
        providersList: null,
        showAgentBenefitAssignment: false,
        adjudicators: [ 'All', 'Unassigned' ],
        agentBenefitsList: null
    };

    static getDerivedStateFromProps(props) {
        if (!permissionLevel('Adjudication', props.master.access).includes('read')) {
            window.location.href = '/403';
        }

        return null;
    }

    async componentDidMount() {
        if (!this.props.claims) {
            this._getClaims(0);
        }

        const adjudicatorsNames = this.props.adjudicators.map((item) => `${ item.firstname } ${ item.lastname }`);
        const agentBenefitsList = await this.props.dispatch(getAgentBenefitAssignments());

        this.setState({
            adjudicators: adjudicatorsNames,
            agentBenefitsList
        });
    }

    _handleInputChange = async (type, value) => {
        if ((value === 'All' || value === 'Submission Date') && type !== 'assignedTo') {
            value = null;
        }

        await this.setState({
            [type]: value
        });

        if (type !== 'query') {
            this._getClaims(0);
        }
    };

    _handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this._getClaims(0);
        }

        return false;
    };

    _getClaims = (cursor = false) => {
        let assignedTo = null;

        // set the adjudicator filter correctly
        if (this.state.assignedTo === 'All') {
            assignedTo = undefined;
        } else if (this.state.assignedTo === 'Unassigned') {
            assignedTo = null;
        } else {
            const adjudicator = this.props.adjudicators.find((item) => `${ item.firstname } ${ item.lastname }` === this.state.assignedTo);
            assignedTo = adjudicator.masterID;
        }

        this.props.dispatch(getClaims({
            ...this.state,
            assignedTo
        }, cursor));
    };

    _toggleAgentBenefitAssignment = () => {
        this.setState({
            showAgentBenefitAssignment: !this.state.showAgentBenefitAssignment
        });
    };

    render() {
        if (!this.props.claims || !this.props.adjudicators || this.props.loader?.isLoading || !this.state.assignedTo) {
            return <Loader isContainer/>;
        }

        return (
            <ContainerControlSite background={"true"} onKeyPress={ (e) => this._handleKeyPress(e) }>
                <Header
                    subHeader="Claims"
                    breadcrumbs={[
                        {
                            title: 'Adjudication',
                            link: `/adjudication`
                        }
                    ]}
                    selectedTitle="adjudication"
                />

                <Content>
                    <PermissionsComponent
                        permission="Assign Agent Benefits"
                        accessType={this.props.master.access}
                        level="read"
                    >
                        <Button
                            color="primary"
                            customStyle={{
                                height: 45,
                                width: 250,
                                float: 'right',
                                textTransform: "capitalize",
                                fontSize: 16
                            }}
                            onClick={this._toggleAgentBenefitAssignment}
                        >
                            Assign Agent Benefits
                        </Button>
                    </PermissionsComponent>

                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={{
                            marginBottom: 20
                        }}
                    >
                        <Grid item xs={12} md={6} lg={8} style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <TextInput
                                label="Search By Claim Identifier"
                                fullWidth
                                value={ this.state.query || '' }
                                variant="outlined"
                                onChange={(e) => this._handleInputChange("query", e.target.value)}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4} style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <TextInput
                                label="Sort Direction"
                                fullWidth
                                value={ this.state.sortDirection || 'DESC' }
                                variant="outlined"
                                onChange={(e) => this._handleInputChange("sortDirection", e.target.value)}
                                select
                                selectOptions={[
                                    'ASC',
                                    'DESC'
                                ]}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4} style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <TextInput
                                label="Benefit"
                                fullWidth
                                value={ this.state.benefit || 'All' }
                                variant="outlined"
                                onChange={(e) => this._handleInputChange("benefit", e.target.value)}
                                select
                                selectOptions={[
                                    'All',
                                    'Dental',
                                    'Drugs',
                                    'Employee Assistance',
                                    'Long Term Disability',
                                    'Health',
                                    'Health Spending',
                                    'Lifestyle Spending',
                                    'Out Of Country',
                                    'Paramedicals',
                                    'Short Term Disability',
                                    'Vision'
                                ]}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4} style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <TextInput
                                label="Category"
                                fullWidth
                                value={ this.state.category || 'All' }
                                variant="outlined"
                                onChange={(e) => this._handleInputChange("category", e.target.value)}
                                select
                                selectOptions={[
                                    'All',
                                    'Acupuncturist',
                                    'Ambulance Services',
                                    'Apnea Machine (CPAP)',
                                    'Apnea Machine Supplies',
                                    'Apnea Mask',
                                    'Artificial Eye/Limb',
                                    'Artificial Eye/Limb Repair/Replacement',
                                    'Audiologist',
                                    'Basic Oral Surgery',
                                    'Blood Pressure Monitor',
                                    'Braces With Rigid Supports',
                                    'Bridge Work',
                                    'Cardiac Rehabilitation',
                                    'Chiropodist',
                                    'Chiropractor',
                                    'Compression Stockings',
                                    'Convalescent Hospital',
                                    'Crowns',
                                    'Crutches',
                                    'Denture Repair',
                                    'Dentures',
                                    'Eldercare',
                                    'Employee Assistance',
                                    'Endodontics',
                                    'Erectile Dysfunction Drugs',
                                    'Long Term Disability',
                                    'Eye Exam',
                                    'Eye Glasses & Contacts',
                                    'Fertility Drugs',
                                    'Generic Drugs',
                                    'Glucose Monitoring Equipment and Supplies',
                                    'Health Spending',
                                    'Hearing Aids',
                                    'Hospital Benefits',
                                    'Insulin Pump',
                                    'Insulin Pump Supplies',
                                    'IPP Breathing Machine',
                                    'Massage',
                                    'Major Oral Surgery',
                                    'Medical Equipment',
                                    'Medical Second Opinion',
                                    'Medical Services & Supplies',
                                    'Mental Health on Demand',
                                    'Naturopath',
                                    'Orthodontics',
                                    'Orthopedic Shoes',
                                    'Orthotics',
                                    'Osteopath',
                                    'Ostomy Supplies',
                                    'Out Of Province',
                                    'Out Of Province Medical Referral',
                                    'Periodontics',
                                    'Physiotherapy',
                                    'Podiatrist',
                                    'Private Duty Nursing',
                                    'Prosthetics',
                                    'Psychologist',
                                    'Registered Dietician',
                                    'Required Safety Eyewear',
                                    'Routine Care',
                                    'Social Worker',
                                    'Speech Therapy',
                                    'Short Term Disability',
                                    'Surgical Bra',
                                    'TENS Machine',
                                    'Viscosupplementation',
                                    'Wheelchair - Electric',
                                    'Wheelchair - Manual',
                                    'Wigs'
                                ]}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4} style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <TextInput
                                label="Sort By"
                                fullWidth
                                value={ this.state.sortBy || 'Submission Date' }
                                variant="outlined"
                                onChange={(e) => this._handleInputChange("sortBy", e.target.value)}
                                select
                                selectOptions={[
                                    'Submission Date',
                                    'Benefit',
                                    'Category',
                                    'Status',
                                    'Amount Paid',
                                    'Amount Submitted'
                                ]}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4} style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <TextInput
                                label="Type"
                                fullWidth
                                value={ this.state.type || 'All' }
                                variant="outlined"
                                onChange={(e) => this._handleInputChange("type", e.target.value)}
                                select
                                selectOptions={[
                                    'All',
                                    'Standard',
                                    'HSA',
                                    'LSA'
                                ]}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4} style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <TextInput
                                label="Status"
                                fullWidth
                                value={ this.state.status === null ? 'All' : this.state.status }
                                variant="outlined"
                                onChange={(e) => this._handleInputChange("status", e.target.value)}
                                select
                                selectOptions={[
                                    'All',
                                    'Pending',
                                    'Approved',
                                    'Referred',
                                    'Paid',
                                    'Declined',
                                    'Suspended',
                                    'Incomplete',
                                    'Reversed'
                                ]}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4} style={{ paddingLeft: 5, paddingRight: 5 }}>
                            <TextInput
                                label="Assigned To"
                                fullWidth
                                value={ this.state.assignedTo }
                                variant="outlined"
                                onChange={ (e) => this._handleInputChange("assignedTo", e.target.value) }
                                select
                                selectOptions={ [ 'All', 'Unassigned', ...this.state.adjudicators ] }
                            />
                        </Grid>
                    </Grid>

                    <ClaimBlock isHeader access={ this.props.master.access } />

                    {
                        this.props.claims.map((claim) => (
                            <ClaimBlock
                                testid={ claim.uid === 'sPCbSn' ? 'claim-block' : ''}
                                key={claim.claimID}
                                claimID={claim.claimID}
                                uid={claim.uid}
                                user={claim.name}
                                cert={claim.cert}
                                submitted={Number(claim.amountSubmitted)}
                                claimed={Number(claim.amountPaid)}
                                status={claim.status}
                                assignedTo={ claim.assignedTo }
                                serviceDate={ claim.serviceDate }
                                submissionDate={ claim.dateAdded }
                                type={claim.type}
                                claimType={claim.claimType}
                                benefit={claim.benefit}
                                isAdjudicationList={true}
                                access={ this.props.master.access }
                                adjudicators={ this.state.adjudicators }
                                claimBlocked={ claim.claimBlocked }
                            />
                        ))
                    }

                    {
                        this.props.claims.length === 0 &&
                        <Text
                            align="center"
                            mediumLarge
                            display="block"
                        >
                            No claims to display
                        </Text>
                    }

                    {
                        this.props.cursor >= 0 &&
                        <Button
                            onClick={() => this._getClaims(false)}
                            color="primary"
                            marginTop={2}
                            fullWidth
                        >
                            Load More
                        </Button>
                    }
                </Content>

                <AgentBenefitAssignment 
                    close={ this._toggleAgentBenefitAssignment }
                    open={ this.state.showAgentBenefitAssignment }
                    adjudicators={ this.state.adjudicators }
                    agentBenefitsList={ this.state.agentBenefitsList }
                />

                <span id="adjudication" />
            </ContainerControlSite>
        );
    }
}

ClaimsList.propTypes = {
    claims: PropTypes.array,
    cursor: PropTypes.number,
    master: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    claims: state.adjudication.claimsList,
    cursor: state.adjudication.cursor,
    master: state.master,
    adjudicators: state.master.adjudicators
});

export default connect(mapStateToProps)(ClaimsList);